import { render, staticRenderFns } from "./rating-inline.vue?vue&type=template&id=1aa5bf88"
import script from "./rating-inline.vue?vue&type=script&lang=js"
export * from "./rating-inline.vue?vue&type=script&lang=js"
import style0 from "./rating-inline.vue?vue&type=style&index=0&id=1aa5bf88&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports